(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-race-menu]').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const trigger = menu.querySelector('summary');
      const close = () => { menu.open = false; trigger.focus(); };
      menu.addEventListener('toggle', () => {
        document.body.classList.toggle('race-menu-open', menu.open);
        trigger.setAttribute('aria-expanded', String(menu.open));
        document.querySelector('#MainContent').inert = menu.open;
        document.querySelector('.shopify-section-group-footer-group')?.toggleAttribute('inert', menu.open);
      });
      menu.querySelector('[data-menu-close]').addEventListener('click', close);
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key !== 'Tab' || !menu.open) return;
        const items = [...menu.querySelectorAll('summary, button, a[href], input')].filter(el => el.getClientRects().length);
        const first = items[0], last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
    });
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), { threshold: 0.08 });
      root.querySelectorAll('[data-race-reveal]').forEach(el => { el.classList.add('race-will-reveal'); observer.observe(el); });
    }
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => {
    document.body.classList.remove('race-menu-open');
    document.querySelector('#MainContent').inert = false;
    document.querySelector('.shopify-section-group-footer-group')?.removeAttribute('inert');
  });
})();
